/**
 * RetainerTracker logo. Inline SVG progress ring + wordmark.
 * Reference: brand kit "Option 3" — charcoal arc + brass arc, rounded stroke ends.
 */

const RingMark = ({ size = 28, light = false, className = "" }) => {
  const charcoal = light ? "#F8F6F1" : "#1F2326";
  const brass = "#B89B5E";
  const r = 22;
  const c = 2 * Math.PI * r; // ~138.23
  // Charcoal arc covers ~75% of the circle. Brass arc covers ~16%. Gap ~9%.
  const charcoalLen = c * 0.74;
  const charcoalGap = c - charcoalLen;
  const brassLen = c * 0.16;
  const brassGap = c - brassLen;
  // Brass arc placed at top-right via rotation offset
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      className={className}
      aria-label="RetainerTracker mark"
      role="img"
    >
      {/* Charcoal arc — starts ~135deg, sweeps clockwise around bottom-left */}
      <circle
        cx="28"
        cy="28"
        r={r}
        fill="none"
        stroke={charcoal}
        strokeWidth="6"
        strokeLinecap="round"
        strokeDasharray={`${charcoalLen} ${charcoalGap}`}
        transform="rotate(115 28 28)"
      />
      {/* Brass arc — top-right small segment */}
      <circle
        cx="28"
        cy="28"
        r={r}
        fill="none"
        stroke={brass}
        strokeWidth="6"
        strokeLinecap="round"
        strokeDasharray={`${brassLen} ${brassGap}`}
        transform="rotate(-65 28 28)"
      />
    </svg>
  );
};

const Logo = ({
  size = 28,
  light = false,
  showWordmark = true,
  showTagline = false,
  className = "",
  textSize = "text-[15px]",
}) => {
  const charcoalText = light ? "text-[#F8F6F1]" : "text-[#1F2326]";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <RingMark size={size} light={light} />
      {showWordmark ? (
        <div className="leading-none">
          <div
            className={`font-display font-semibold ${textSize}`}
            style={{ letterSpacing: "-0.02em" }}
          >
            <span className={charcoalText}>Retainer</span>
            <span className="text-[#B89B5E]">Tracker</span>
          </div>
          {showTagline ? (
            <div className={`text-[10px] ${light ? "text-[#C9C2B0]" : "text-[#69747C]"} font-normal mt-1.5 tracking-wider uppercase`}>
              Track Hours · Protect Profits
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export { RingMark };
export default Logo;
